import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import LocalizationService from '@/services/localization-service'

async function checkRouteLocaleGuard(to: Route, from: Route, next: NavigationGuardNext) {
  if (to.query.locale) {
    const locale = `${to.query.locale || ''}`
    const localeName = locale?.split('_')?.[0]

    const branchLocales = store.getters['branches/currentBranch']?.locales
    if (localeName && localeName !== LocalizationService.getCurrentLocale() && (!branchLocales || branchLocales.includes(localeName))) {
      LocalizationService.setLocale(localeName)
    }
  }

  return next()
}

export default checkRouteLocaleGuard
